import {create} from "zustand/index";
import {guardarDataLocal} from "../../Modulo_Optimizacion_Data/Funciones/guardarDataLocal";

export const useFuncionesCarritoLateral = create((set, get) => {

    const setProductos = (productos) => {

        set(() => ({productos: productos}))
    }

    const verificarProductoCarrito = (e) => {

        let products = get().productos
        let index = products.findIndex((it) => it.id === e.id)

        if (index >= 0) {
            return true
        } else {
            return false
        }


    }

    const resetarCarrito = () => {
        set(() => ({productos: []}))
    }

    const quitarProducto = (e) => {

        let products = get().productos
        let index = products.findIndex((it) => it.id === e.id)

        products.splice(index, 1)

        guardarDataLocal({clave: 'carrito', data: products})

        set(() => ({productos: products}))

    }


    const adicionarProducto = (producto) => {

        let productosArr = get().productos
        let index = productosArr.findIndex((it) => it.id === producto.id)

        if (index > -1) {
            let productoActual = productosArr[index]
            productoActual.cantidad = productoActual.cantidad + producto.cantidad
            productosArr[index] = productoActual
        } else {
            productosArr.push(producto)
        }

        guardarDataLocal({clave: 'carrito', data: productosArr})
        set(() => ({productos: productosArr}))
    }


    const adicionarCantidadProducto = ({idProducto, cantidad = 1}) => {

        let productosArr = get().productos
        let index = productosArr.findIndex((it) => it.id === idProducto)

        if (index > -1) {
            let productoActual = productosArr[index]
            productoActual.cantidad = productoActual.cantidad + cantidad
            productosArr[index] = productoActual

            guardarDataLocal({clave: 'carrito', data: productosArr})
            set(() => ({productos: productosArr}))
        }

    }

    const restarCantidadProducto = ({idProducto, cantidad = 1}) => {

        let productosArr = get().productos
        let index = productosArr.findIndex((it) => it.id === idProducto)


        if (index > -1) {
            let productoActual = productosArr[index]
            if (productoActual.cantidad >= 2) {
                productoActual.cantidad = productoActual.cantidad - cantidad
                productosArr[index] = productoActual
                set(() => ({productos: productosArr}))
            } else {

                productosArr.splice(index, 1)
                guardarDataLocal({clave: 'carrito', data: productosArr})
                set(() => ({productos: productosArr}))
            }


        }

    }

    return {
        productos: [],
        adicionarProducto,
        verificarProductoCarrito,
        quitarProducto,
        adicionarCantidadProducto,
        restarCantidadProducto,
        setProductos,
        resetarCarrito

    }
})